import moment from "moment";

const getDauerInMinuten = (veranstaltung) => {
    const beginn = moment(veranstaltung.beginn);
    const ende = moment(veranstaltung.ende);
    const duration = moment.duration(ende.diff(beginn));
    return duration.asMinutes();
}

const summeRefPunkte = (teilnahmen) =>
    Object.values(teilnahmen).reduce((summe, teilnahme) => summe + teilnahme.punkte_referent, 0);

/**
 * Fortbildungsordnung Hessen, Kategorie F: 1 Punkt pro Beitrag (z. B. 45-minütiger Vortrag)
 * in den Kategorien A und H, dazu 1 Punkt für die Wissenschaftliche Leitung. Andere
 * Kategorien: nur der eine WL-/Moderationspunkt.
 */
const kategorienMitVergabeDerRefPunkte = ["A", "H"];

const estimateMaxAllowedRefPunkte = (veranstaltung) => {
    if (kategorienMitVergabeDerRefPunkte.indexOf(veranstaltung.kategorie) >= 0){
        //hier gilt so etwa dauer in minuten / 45 + 1 punkt für WL
        const minuten = getDauerInMinuten(veranstaltung);
        if(minuten > 480) return 12;
        return 1 + Math.ceil(minuten / 45);
    }
    return 1;
}

const validatorHessen = {
    bezeichnung: "Hessen: Ref.-Punkte in den Kategorien A und H, 1 Punkt je 45-Minuten-Beitrag",
    istPlausibel: (veranstaltung, teilnahmen) =>
        estimateMaxAllowedRefPunkte(veranstaltung) >= summeRefPunkte(teilnahmen)
};

/**
 * Validatoren je Kammer, Schlüssel sind die ersten 6 Stellen der VNR (ISO-3166-Land + KID).
 *
 * Bewusst nur für Kammern, deren Regel zur Vergabe der Ref/Mod/WL-Punkte bekannt ist: Die
 * hessische Prüfung lässt sich nicht auf andere übertragen, da z. B. die Muster-FBO der BÄK
 * die Beschränkung auf die Kategorien A und H nicht kennt. Ohne Eintrag wird nicht geprüft
 * und nicht gewarnt - die App bleibt dort reines Meldewerkzeug. Das gilt auch für die
 * künftig angeschlossenen Kammern in Österreich und die Psychotherapeutenkammern.
 *
 * Neue Kammer: eigenen Validator anlegen (die istPlausibel-Logik darf beliebig abweichen,
 * z. B. je Person statt über die Summe) und hier eintragen. Der zugehörige Warntext gehört
 * in die Kammer-Zuordnung in VeranstaltungPage.js.
 */
const validatorenNachLandKammerId = {
    '276060': validatorHessen
};

export const getRefPunkteValidator = (vnr) =>
    vnr ? validatorenNachLandKammerId[vnr.substring(0, 6)] : undefined;

/**
 * Rückgabewert ist "die Punkte sind plausibel". Ohne hinterlegten Validator oder ohne
 * geladene Daten gibt es nichts Unplausibles, also true - ein false würde die Warnung
 * auslösen, solange noch nichts bekannt ist.
 */
export const validateRefPunkte = (vnr, veranstaltung, erfassteTeilnahmen, teilnahmeMeldungen) => {
    const validator = getRefPunkteValidator(vnr);
    if( !validator || !veranstaltung ) return true;
    return validator.istPlausibel(veranstaltung, {...teilnahmeMeldungen, ...erfassteTeilnahmen });
}

export const validateGemeldeteRefPunkte = (vnr, veranstaltung, teilnahmeMeldungen) => {
    const validator = getRefPunkteValidator(vnr);
    if( !validator || !veranstaltung || !teilnahmeMeldungen ) return true;
    return validator.istPlausibel(veranstaltung, teilnahmeMeldungen);
}
